import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import {
  ReferralCodeFormFields,
  toFormValues,
  toPayload,
  type ReferralCodeFormValues,
} from './form-fields';

export const ReferralCodeEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({
    resource: 'referral-codes',
    redirect: 'list',
  });
  const record = queryResult?.data?.data;

  return (
    <Edit resource="referral-codes" title="Edit Referral Code" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        initialValues={toFormValues(formProps.initialValues)}
        layout="vertical"
        onFinish={(values) => formProps.onFinish?.(toPayload(values as ReferralCodeFormValues))}
      >
        <ReferralCodeFormFields codeLocked={(record?.redemptionCount ?? 0) > 0} />
      </Form>
    </Edit>
  );
};
